import { cleanText, pickKoreanTitle } from "../lib/utils";

export default function PCThemeWidget({ themes, onSelect }) {
  if (!themes?.length) return null;

  return (
    <div style={{ padding: "20px 28px", borderBottom: "1px solid var(--pc-line-3)" }}>
      <div style={{
        display: "grid",
        gridTemplateColumns: `repeat(${Math.min(themes.length, 3)}, 1fr)`,
        gap: 0,
      }}>
        {themes.slice(0, 3).map((th, ti, arr) => (
          <div
            key={ti}
            style={{
              padding: ti === 0 ? "0 24px 0 0" : ti === arr.length - 1 ? "0 0 0 24px" : "0 24px",
              position: "relative",
            }}
          >
            {ti < arr.length - 1 && (
              <span style={{ position: "absolute", right: 0, top: "12%", bottom: "12%", width: 1, background: "var(--pc-line-3)" }} />
            )}
            <div style={{ display: "flex", gap: 6, alignItems: "baseline", marginBottom: 6 }}>
              <span style={{ fontSize: 13, fontWeight: 700, letterSpacing: ".01em", color: "var(--pc-fg-1)" }}>
                {cleanText(th.label)}
              </span>
            </div>
            {(th.articles || []).slice(0, 3).map((a, i) => (
              <div
                key={i}
                onClick={() => onSelect && onSelect(a)}
                style={{
                  fontSize: 12.5,
                  color: "var(--pc-fg-2)",
                  lineHeight: 1.45,
                  marginBottom: 3,
                  cursor: "pointer",
                }}
              >
                · {cleanText(pickKoreanTitle(a.hed_ko, a.hed))}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
